import { clamp, bookmarkAt, sortedBookmarks } from './utils.js';

export const LOOP_MODES = Object.freeze(['off', 'song', 'passage', 'bookmark']);
export const loopMode = project => project?.loopMode ?? (project?.bookmarkLoop ? 'bookmark' : project?.loop?.enabled ? 'passage' : 'off');

export function setLoopMode(project, mode) {
  project.loopMode = mode;
  project.bookmarkLoop = mode === 'bookmark';
  project.loop.enabled = mode === 'passage' && project.loop.a != null && project.loop.b != null;
}

export function bookmarkLoopRange(bookmarks, time, duration) {
  const points = [0, ...sortedBookmarks(bookmarks).map(b => b.time), duration]
    .filter((point, index, all) => point >= 0 && point <= duration && (!index || point !== all[index - 1]));
  for (let i = 0; i < points.length - 1; i++) {
    if ((time < points[i + 1] || i === points.length - 2) && points[i + 1] > points[i]) {
      return { a: points[i], b: points[i + 1] };
    }
  }
  return null;
}

export function markerTime(project, kind, id, value, duration) {
  if (!project || !Number.isFinite(value) || !(duration > 0)) return null;
  if (kind === 'bookmark') {
    if (!project.bookmarks.some(b => b.id === id)) return null;
    const time = clamp(value, 0, duration);
    return bookmarkAt(project.bookmarks.filter(b => b.id !== id), time) ? null : time;
  }
  const loop = project.loop;
  if (kind !== 'loop' || !['a', 'b'].includes(id) || loop[id] == null) return null;
  const min = id === 'b' ? loop.a + .25 : 0;
  const max = id === 'a' && loop.b != null ? loop.b - .25 : duration;
  return min <= max ? clamp(value, min, max) : null;
}
